import Breadcrumbs from "../../components/Common/Breadcrumb";
import React, {useEffect, useState} from "react";
import {Card, Col, Row, Space} from "antd";
import {Button, CardBody, CardHeader} from "reactstrap";
import AddCoupons from "./AddCoupons";
import ListCoupons from "./List/ListCoupons";
import Paging from "../../components/Pagination/Pagination";
import {connect} from "react-redux";
import {getCoupons} from "../../store/coupons/actions";
import Search from "../../components/Search/Search";
import ViewUsedCoupon from "./List/ViewUsedCoupon";
import ListSearch from "components/ListSearch/ListSearch";

const Coupons = ({couponsList, getCoupons}) => {

  const options = [
    {keySearch: 'couponCode', titleSearch: 'Код'},
    {keySearch: 'forProfessionals.name_forProfessionals.surname', titleSearch: 'Име на специалист'},
    {keySearch: 'forParents.name_forParents.surname', titleSearch: 'Име на стопанин'},
    {keySearch: 'validDateFrom', titleSearch: 'Начална дата'},
    {keySearch: 'validDateTo', titleSearch: 'Крайна дата'},
  ]

  const [onNewCouponModal, setOnNewCouponModal] = useState(false)
  const [filterModalOpen, setFilterModalOpen] = useState(false)
  const [currentCoupon, setCurrentCoupon] = useState({})
  const [currentPage, setCurrentPage] = useState(1)
  const [pageSize, setPageSize] = useState(20)
  const [viewUsedCoupon, setViewUsedCoupon] = useState(null)
  const [showUsedCoupon, setShowUsedCoupon] = useState(false)
  const [search, setSearch] = useState({text: '', filter: '', tagsFilters: {}})
  const [q, setQ] = useState('')

  useEffect(() => {
    const searchPayload = (search.text && search.filter) || Object.keys(search.tagsFilters).length > 0 ? { search: JSON.stringify(search) } : {};
    getCoupons({ page: currentPage, pageSize, q, ...searchPayload });
  }, [currentPage, search, pageSize, q, getCoupons])

  const refreshPage = (e) => {
    e.preventDefault()
    setSearch({text: '', filter: '', tagsFilters: {}})
    setCurrentPage(1)
  }
  const onSubmit = (e, newSearch) => {
    e.preventDefault()
    setFilterModalOpen(false)
    setCurrentPage(1)
    setSearch(newSearch)
  }
  const handleTextSearch = (value) => {
    setQ(value)
    setCurrentPage(1)
  }


  return <React.Fragment>
    <div className="page-content w-100">
      <div className="container-fluid">
        <Breadcrumbs title="Купони" breadcrumbItem="Купони"/>

        <Row>
          <Col>
            <Card>
              <CardHeader>
                <Button
                  color="success"
                  className="btn btn-success waves-effect waves-light"
                  onClick={() => {
                    setOnNewCouponModal(!onNewCouponModal)
                    setCurrentCoupon({})
                  }}
                >
                  {" "}
                  <i className=""> </i> Добави купон
                </Button>
              </CardHeader>
              <div className="list-toolbar py-2">
                <Paging setPage={setCurrentPage} setPageSize={setPageSize} pageSize={pageSize} currentPage={currentPage} pages={couponsList?.pages}/>
                <ListSearch
                  value={q}
                  onSearch={handleTextSearch}
                  placeholder="Търсене по код, специалист или стопанин"
                />
                <Space direction="horizontal" className="mr-4">
                  <Button type={'button'} className='btn btn-info waves-effect waves-light search-btn'
                          onClick={() => setFilterModalOpen(!filterModalOpen)}><i
                    className="bx bx-filter-alt align-middle"></i></Button>
                  {(search.text || Object.keys(search.tagsFilters).length > 0) &&
                    <Button type={'button'} className='btn btn-dark waves-effect waves-light search-btn'
                            onClick={refreshPage}><i
                      className='bx bx-revision align-middle'></i></Button>}
                </Space>
              </div>
              <CardBody>

                <ListCoupons setCouponEdit={setCurrentCoupon}
                             setOnEditCouponModalOpen={setOnNewCouponModal}
                             showUsedCoupon={(usedCoupon) => {
                               setViewUsedCoupon(usedCoupon)
                               setShowUsedCoupon(!showUsedCoupon)
                             }}
                             couponsList={couponsList?.coupons}
                             used={couponsList?.usedCouponCount}/>

              </CardBody>
              <div className="d-inline-flex ant-row-space-between align-items-center">
                <Paging setPage={setCurrentPage} setPageSize={setPageSize} pageSize={pageSize} currentPage={currentPage} pages={couponsList?.pages}/>
              </div>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
    <AddCoupons currentCoupon={currentCoupon} isNewCouponModalOpen={onNewCouponModal}
                onCancel={() => setOnNewCouponModal(!onNewCouponModal)}/>
    {showUsedCoupon ? <ViewUsedCoupon viewCoupon={viewUsedCoupon} showUsedCoupon={showUsedCoupon} onCancel={() => setShowUsedCoupon(false)}/> : null}
    <Search searchModalOpen={filterModalOpen}
            options={options}
            filterData={['validDateFrom', 'validDateTo']}
            searchVar={search}
            tags={[]}
            onSubmit={onSubmit}
            onCancel={() => setFilterModalOpen(false)}/>
  </React.Fragment>
}
const mapStateToProps = (state) => {
  const {Coupons} = state;
  // The component expects `couponsList` to be an object with `pages` and `coupons`.
  // If the `Coupons` state slice is undefined, we provide a default structure
  // to prevent the app from crashing and fix the NaN issue in pagination.
  return Coupons || { couponsList: { pages: 1, coupons: [] } };
}
export default connect(mapStateToProps, {getCoupons})(Coupons)
